export function formatLapTime(seconds) {
  if (seconds == null) return '--:--.---';
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toFixed(3).padStart(6, '0')}`;
}

export function formatDelta(deltaSeconds) {
  if (deltaSeconds == null) return '';
  const sign = deltaSeconds >= 0 ? '+' : '-';
  const abs = Math.abs(deltaSeconds);
  return `${sign}${abs.toFixed(3)}`;
}

export function formatDate(dateStr) {
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function formatG(value) {
  if (value == null) return '--';
  return value.toFixed(2) + ' G';
}

export function formatSpeed(value, user) {
  if (value == null) return '--';
  const isMetric = user?.units === 'metric';
  const converted = isMetric ? value * 1.60934 : value;
  const unit = isMetric ? 'km/h' : 'MPH';
  return Math.round(converted) + ' ' + unit;
}
